var _line, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.515625,
    y1: 5.98398,
    x2: 23.5156,
    y2: 5.98398,
    stroke: "#1B0076",
    strokeWidth: 1.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36563,
    y: 1.68398,
    width: 22.3,
    height: 16.3,
    rx: 1.15,
    stroke: "#1B0076",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadline);
export default __webpack_public_path__ + "static/media/headline.7e795141.svg";
export { ForwardRef as ReactComponent };